import React from 'react'
import Header from "../components/header/header";
import LeadGeneration from "../sections/LeadGeneration/LeadGeneration"
import Footer from "../components/footer/footer";

function Leadgeneration() {
    return (
        <>
            <Header />
            <LeadGeneration />
            <Footer />
        </>
    )
}

export default Leadgeneration
